/**
 * Name: Burger
 */

import Collapsible from "@lunaweb/vega-reactor-js/src/patterns/Collapsible";

export default class Burger extends Collapsible {
  static settings = {
    control: '.js-burger',
    target: '.js-navigations',
  };

  constructor (element, options = {}) {
    super(element, {
      ...Burger.settings,
      ...options,
    });

    this.handleLinkClicks = this.handleLinkClicks.bind(this);
  }

  get isDisplayed () {
    return getComputedStyle(this.element).display !== 'none';
  }

  open () {
    super.open();
    document.querySelector('header').classList.add('is-open');
    document.querySelector('.js-burger span').innerHTML = "Fermer";
    document.querySelector('html').classList.add('no-scroll');
    document.querySelector('header').ontransitionend = () => {
      document.querySelector('header').scrollTop = 0;
    };

    if (document.body.classList.contains("admin-bar")) {
      document.querySelector('header').style.top = `${50}px`;
    }

    this.target.focus();

    this.target.addEventListener('click', this.handleLinkClicks);
  }

  close () {
    super.close();
    document.querySelector('header').classList.remove('is-open');
    document.querySelector('.js-burger span').innerHTML = "Menu";
    document.querySelector('header').classList.remove('is-megamenu-open');
    document.querySelector('html').classList.remove('no-scroll');

    if (document.body.classList.contains("admin-bar")) {
      document.querySelector('header').style.top = `0`;
    }

    this.target.removeEventListener('click', this.handleLinkClicks);
  }

  handleLinkClicks(event) {
    const clickedElement = event.target;

    const linkElement = clickedElement.closest('a');

    if (linkElement && !linkElement.hasAttribute('role') && linkElement.getAttribute('href') !== '#') {
      this.close();
    }
  }

  mount () {
    super.mount();
    this.target.setAttribute('tabindex', '-1');

    requestAnimationFrame(() => {
      if (document.activeElement) {
        document.activeElement.blur();
      }
    });
  }

  unmount () {
    super.unmount();
    this.target.classList.remove('has-open');
    document.querySelector('.js-burger span').innerHTML = "Menu";
    this.target.removeEventListener('click', this.handleLinkClicks);
  }
}
